import { uniq } from 'lodash';
import { BrowserStorage } from './browser';

const colorPaletteStorageKey = 'givz-colors-palette';
export const defaultPaletteSize = 4;

export function getStoredColors(): string[] {
  return BrowserStorage.get(colorPaletteStorageKey)?.split(',') ?? [];
}

export function saveColor(color: string, paletteSize = defaultPaletteSize) {
  const colors = getStoredColors();
  colors.splice(0, 0, color);
  BrowserStorage.set(
    colorPaletteStorageKey,
    uniq(colors).slice(0, paletteSize).join(','),
  );
}
